import React from "react";
import Store, { Provider } from "~/common/Store";
import MailingList from "./MailingList";
import Subfooter from "./Subfooter";
import MainFooter from "./MainFooter";
import FooterCTA from "./FooterCTA";
import { defaultUserObject } from "../Store/rootReducer";
import useIsMounted from "../useIsMounted";
import ExternalLinkModal from "../ExternalLinkModal/ExternalLinkModal";
export default function Footer(): JSX.Element {
  const mounted = useIsMounted();
  const sharedBorderStyles = "border-gray-300 border-solid";
  return <Provider store={Store} data-sentry-element="Provider" data-sentry-component="Footer" data-sentry-source-file="index.tsx">
      <footer aria-label="Website Footer" className="z-20 relative">
        <div className={`bg-gray-50 clear-both mt-16 border-0 border-t overflow-hidden ${sharedBorderStyles}`}>
          <div className="container mx-auto mt-0 max-w-none px-0 lg:px-7 xl:max-w-full xl:px-10 xxl:px-[7%]">
            <div className="!flex flex-col md:items-center lg:flex-row lg:justify-between">
              {mounted ? <div className="!flex flex-col lg:flex-row md:w-full md:items-center">
                  <MailingList mounted={mounted} user={defaultUserObject} />
                  <FooterCTA mounted={mounted} user={defaultUserObject} />
                </div> : null}
            </div>
          </div>
        </div>
        <div className="bg-green-800">
          <div className="container">
            <MainFooter data-sentry-element="MainFooter" data-sentry-source-file="index.tsx" />
            <hr className="border-0 bg-green-500 mt-0 mb-6 md:mb-4 h-px" />
            <Subfooter data-sentry-element="Subfooter" data-sentry-source-file="index.tsx" />
          </div>
        </div>
        <ExternalLinkModal data-sentry-element="ExternalLinkModal" data-sentry-source-file="index.tsx" />
      </footer>
    </Provider>;
}